import React, {useContext} from "react"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Tag from "@amzn/meridian/tag";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import Column from "@amzn/meridian/column";
import {injectIntl} from "react-intl";

const AssociateFilter = ({intl}) => {
    const {states, dispatch} = useContext(AssociateFilterContext)
    return (
        <Column spacingInset="medium none" width={"100%"}>
            <Row width="100%" backgroundColor="secondary" spacingInset="small medium">
                <ControlGroup
                    label={intl.formatMessage({id: 'associate.active', defaultMessage: 'Active'})}
                    name="state"
                    onChange={(data) => dispatch({type: 'SELECT_STATE', state: data})}
                    value={states}>
                    <Checkbox key="yes" value="Yes">Yes</Checkbox>
                    <Checkbox key="no" value="No">No</Checkbox>
                </ControlGroup>
            </Row>
                <Row width="100%" spacingInset="none">
                    <Box>
                        <div className="filter-tag">
                            {states.map(state => {
                                return <Tag key={state}
                                            onClose={() => dispatch({type: 'REMOVE_STATE', state})}
                                            type="theme">{state}</Tag>
                            })}
                        </div>
                    </Box>
                </Row>
        </Column>
    )
}

export default injectIntl(AssociateFilter)  


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociateFilter.js